import { EntitiesStore } from './entities-store.abstract';
import { HttpClient } from '@angular/common/http';
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';


/**
 * Interface that represents an phase
 *
 * @interface IPhase
 */
export interface IPhase {
  Id: string;
  Name: string;
  ShortName: string;
  Level: string;

}

/**
 * Store for getting the phases
 *
 * @export
 * @class PhaseStore
 * @extends {EntitiesStore<IOfficial>}
 */
export class PhaseStore extends EntitiesStore<IPhase>  {
  constructor(http: HttpClient) {
    super('PHASES', http);
  }

  /**
   * Method for obtain the phase name using the id.
   *
   * @param {string} id the id of the phase.
   * @memberof PhaseStore
   */
  getPhaseNameById(id: string) {
    return this.data.length !== 0 ? this.data.find(value => value.Id.toString() === id.toString()).Name : '';
  }
}
